var exports = {
  "zr": "x1cb7f6e3--e0f547--root",
  "wx": "x1cb7f6e3--e0f547--header",
  "h_": "x1cb7f6e3--e0f547--description",
  "Qq": "x1cb7f6e3--e0f547--text",
};

module.exports = exports;
